import type {
  CourseListServiceConfig,
  CreateCourseServiceConfig,
  DeleteCourseServiceConfig,
  GetCourseByIdServiceConfig,
  GetCourseHandoutServiceConfig,
  LinkableCoursesServiceConfig,
  LinkUnitToCourseServiceConfig,
  ReorderCoursesServiceConfig,
  SearchTPLinkableServiceConfig,
  UnlinkUnitFromCourseServiceConfig,
  UpdateCourseServiceConfig,
  ValidateUnitServiceConfig,
} from '@/services/httpServices/CourseServices/types';

import { createQueryKey } from './queryKeyUtils';

export function courseListKeys(params?: CourseListServiceConfig) {
  return createQueryKey(['courseList'], params);
}

/**
 * Creates a unique query key for infinite course list queries.
 * Includes 'infinite' prefix to differentiate from regular list queries —
 * mirrors the convention used by ABTest / Quiz / Sequence infinite keys.
 */
export function infiniteCourseListKeys(params?: CourseListServiceConfig) {
  return ['infinite', ...courseListKeys(params)];
}

export function courseByIdKeys(params?:
  | GetCourseByIdServiceConfig
  | DeleteCourseServiceConfig
  | UpdateCourseServiceConfig
  | CreateCourseServiceConfig
  | UnlinkUnitFromCourseServiceConfig
  | LinkUnitToCourseServiceConfig
  | ReorderCoursesServiceConfig) {
  return createQueryKey(['courseById'], params);
}

export function courseLinkableKeys(params?: LinkableCoursesServiceConfig) {
  return createQueryKey(['courseLinkable'], params);
}

export function courseValidationKeys(params?: GetCourseByIdServiceConfig) {
  return createQueryKey(['courseValidation'], params);
}

export function courseHandoutKeys(params?: GetCourseHandoutServiceConfig) {
  return createQueryKey(['courseHandout'], params);
}

export function searchTPLinkableKeys(params?: SearchTPLinkableServiceConfig) {
  return createQueryKey(['searchTPLinkable'], params);
}

export function unitValidationKeys(params?: ValidateUnitServiceConfig) {
  return createQueryKey(['unitValidation'], params);
}
